import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

import buildPath from '../utilities/buildPath';

type ThisApi =
  ApiDefinition['/plaid/{creatorId}/bank-account-integrations/{bankAccountIntegrationId}/documents']['POST'];
type Input = ThisApi['body'] & ThisApi['params'];
type Output = ThisApi['response'];

const getBankAccountDocumentsFromPlaid = async ({
  creatorId,
  publicToken,
  bankAccountIntegrationId,
  metaData,
}: Input): Promise<Output> => {
  const path = buildPath('/plaid/{creatorId}/bank-account-integrations/{bankAccountIntegrationId}/documents', {
    bankAccountIntegrationId,
    creatorId,
  });
  const response = await noodleApiClient.post(path, { metaData, publicToken });
  return response.data;
};

export default getBankAccountDocumentsFromPlaid;
